import { AgeingTypes } from '@mews-commander/data-access';

export const getAgeingType = (values: string[]): AgeingTypes[] | null => {
    if (!Array.isArray(values) || values.length === 0) {
        return [];
    }

    return values.map((value) => AgeingTypes[value as keyof typeof AgeingTypes]);
};
